module.exports = __webpack_public_path__ + "static/media/cq_conferma_salva.f3bbc6c1.svg";